import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import styled from "styled-components/macro";

import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import API from "Signups/API";
import { checkForPaidRespondents } from "Signups/SignupView/SignupSheet/utils/checkForPaidRespondents";
import { useSignups } from "Signups/state.js";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

DeleteConfirmation.propTypes = {
  show: PropTypes.bool,
  buttonRef: PropTypes.object,
  peopleHaveSignedUp: PropTypes.bool,
  signupListID: PropTypes.number,
  closePopover: PropTypes.func,
};

export default function DeleteConfirmation({
  show,
  buttonRef,
  peopleHaveSignedUp,
  signupListID,
  closePopover,
}) {
  const history = useHistory();
  const [state] = useSignups();
  const [status, setStatus] = useState(null);

  const hasAnyPaidRespondents = () => {
    return state.currentSignupList.signupItems.some((item) => {
      return checkForPaidRespondents(item.respondents);
    });
  };
  const paidRespondentsFound = hasAnyPaidRespondents();

  const deleteSignup = () => {
    setStatus("loading");

    API.deleteSignupList(signupListID)
      .post()
      .then(() => {
        setStatus(null);
        history.push("/signups");
      })
      .catch(() => {
        setStatus("error");
      });
  };

  const popoverStyle = {
    backgroundImage:
      "linear-gradient( to right bottom, rgba(180, 37, 45, 0.7), rgba(128, 36, 40, 0.7) )",
  };

  if (status === "error") {
    return (
      <FnrPopover
        style={popoverStyle}
        show={show}
        buttonRef={buttonRef}
        onShouldClose={closePopover}
      >
        <Confirmation onClick={(e) => e.stopPropagation()}>
          Oh no! We hit a snag- please try again later or contact{" "}
          <a href="mailto:help@flocknote.com">help@flocknote.com</a>
          <ButtonRow>
            <FnrButton onClick={closePopover}>Cancel</FnrButton>
          </ButtonRow>
        </Confirmation>
      </FnrPopover>
    );
  }

  return (
    <FnrPopover
      style={popoverStyle}
      show={show}
      buttonRef={buttonRef}
      onShouldClose={closePopover}
    >
      <Confirmation onClick={(e) => e.stopPropagation()}>
        <strong>Are you sure?</strong> Deleting a signup is permanent and cannot
        be undone.
        {peopleHaveSignedUp ? (
          <Warning>
            <FontAwesomeIcon icon={faExclamationCircle} /> This will clear all
            of the people currently signed up!
          </Warning>
        ) : null}
        {paidRespondentsFound ? (
          <Warning>
            <FontAwesomeIcon icon={faExclamationCircle} /> Refunds will not be
            issued for any signup payments that have been received.
          </Warning>
        ) : null}
        <ButtonRow>
          <FnrButton onClick={closePopover}>Cancel</FnrButton>
          <FnrButton
            color="red"
            onClick={deleteSignup}
            loading={status === "loading"}
            data-cy="delete-confirmation-button"
          >
            <ButtonText>Delete</ButtonText>
            <ButtonIcon fas fa-trash />
          </FnrButton>
        </ButtonRow>
      </Confirmation>
    </FnrPopover>
  );
}

const Confirmation = styled.div`
  font-size: 16px;
  padding: 8px;
  width: 300px;
  box-sizing: border-box;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
`;

const Warning = styled.div`
  margin-top: 10px;
  font-size: 14px;
`;
